import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../common';
import { IProvider, IProviderFilter } from './models';

export const providersApiSlice = createApi({
  reducerPath: 'provider/api',
  baseQuery: axiosBaseQuery({
    baseUrl: 'orderingproviders/',
  }),
  endpoints: builder => ({
    getProviders: builder.query<IProvider[], IProviderFilter>({
      query: data => ({
        url: `fn/search`,
        method: 'POST',
        data,
      }),
      transformResponse: (response: IAxiosResponse<IProvider[]>): IProvider[] => response.data,
    }),
  }),
});
